module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Import-34589434947b29ba9289b83565c82aa4.svg";